<template>
	<Card>
		<div class="container-fluid">
			<div class="row pt-3 pl-2">
				<h5 class="back-title" @click="back()">
					<i class="fa fa-angle-left"></i> Back To Admin
				</h5>
			</div>
			<div class="row">
				<h4 class="account-title col-sm-2 offset-sm-2">Account details</h4>
			</div>
			<div class="row form-group pl-5 pr-5">
				<label for="name" class="col-sm-2 offset-sm-3">Name:</label>
				<input id="name" type="text" v-model="updatedUser.name" class="col-sm-3" required/>
			</div>
			<div class="row form-group pl-5 pr-5">
				<label for="email" class="col-sm-2 offset-sm-3">Email:</label>
				<input id="email" type="text" v-model="updatedUser.email" class="col-sm-3" required/>
			</div>
			<div class="row form-group pl-5 pr-5">
				<label for="password" class="col-sm-2 offset-sm-3">Password:</label>
				<input
					id="password"
					type="password"
					v-model="updatedUser.password"
					class="col-sm-3"
					required
				/>
			</div>
			<div class="row form-group pl-5 pr-5">
				<label for="repassword" class="col-sm-2 offset-sm-3">Re-enter Password:</label>
				<input
					id="repassword"
					type="password"
					v-model="updatedUser.repassword"
					class="col-sm-3"
					required
				/>
			</div>
			<div v-if="updateErrorMessages.length > 0"  class="row form-group pl-5 pr-5 mb-5" style="justify-content: center;text-align: left;">
				<p v-for="error in updateErrorMessages" style="color: #8D448B !important; display: block;">
					{{ error }}
				</p>
			</div>
			<div class="row form-group text-right pr-4">
				<button  @click="updatePassword" class="update-button col-sm-1 offset-sm-7">
					Update
				</button>
			</div>

			<div class="row">
				<div class="col-sm-12">
					<div class="row">
						<h4 class="show-title col-sm-2 offset-sm-2" @click="showCurrentUsers=!showCurrentUsers">Show Current Users</h4>
					</div>
					<div class="row" v-show="showCurrentUsers">
						<div class="col-sm-6 offset-sm-2">

							<table>
								<thead>
									<tr>
										<th>Name</th>
										<th>Email</th>
										<th>Access Level</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="user in linkedUsers">
										<td>{{ user['name'] }}</td>
										<td>{{ user['email'] }}</td>
										<td>{{ user['access_level'] }}</td>
									</tr>
									
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
			<div class="row"  v-if="user && user.isSuperAdmin">
				<div class="col-sm-12">
					<div class="row">
						<h4 class="account-title col-sm-2 offset-sm-2">Add New User</h4>
					</div>
					<div class="row form-group pl-5 pr-5">
						<label for="name1" class="col-sm-2 offset-sm-3">Name:</label>
						<input id="name1" type="text" v-model="newUser.name" class="col-sm-3" required/>
					</div>
					<div class="row form-group pl-5 pr-5">
						<label for="email1" class="col-sm-2 offset-sm-3">Email:</label>
						<input id="email1" type="text" v-model="newUser.email" class="col-sm-3" required/>
					</div>
					<div class="row form-group pl-5 pr-5">
						<label for="password1" class="col-sm-2 offset-sm-3">Password:</label>
						<input
							id="password1"
							type="password"
							v-model="newUser.password"
							class="col-sm-3"
							required
						/>
					</div>
					<div class="row form-group pl-5 pr-5">
						<label for="repassword1" class="col-sm-2 offset-sm-3">Re-enter Password:</label
						>
						<input
							id="repassword1"
							type="password"
							v-model="newUser.repassword"
							class="col-sm-3"
							required
						/>
					</div>
					
					<div class="row form-group pl-5 pr-5">
						<label for="access_level" class="col-sm-2 offset-sm-3">Access Level:</label>
						<select
							id="access_level"
							@change="selectField($event)"
							v-model="newUser.isAdmin"
						>
							<option v-for="admin in adminValues" :value="admin.value">
								{{ admin.label }}
							</option>
						</select>
					</div>
					<div class="row form-group pl-5 pr-5" v-show="newUser.isAdmin == 1">
						<label for="access_level" class="col-sm-2 offset-sm-3">Link sites to Admin user</label>
						<div class="col-sm-7">
							<multi-select
								ref="multselect"
								:type="'site'"
								:options="linkedSites"
								@checked="onCheck"
							></multi-select>
						</div>
						
					</div>
					<div v-if="errorMessages.length > 0"  class="row form-group pl-5 pr-5 mb-5" style="justify-content: center;text-align: left;">
						<p v-for="error in errorMessages" style="color: #8D448B !important; display: block;">
							{{ error }}
						</p>
					</div>
					<div class="row form-group text-right pr-4">
						<button  @click="createNewUser" class="update-button col-sm-1 offset-sm-7">
							Create
						</button>
					</div>
				</div>
			</div>

			<div class="row pt-3">
				<h4 class="account-title col-sm-8 offset-sm-2">
					Power Manager Channels ({{ sitename }})
				</h4>
			</div>
			<div class="row pr-5">
				<div class="col-sm-6 offset-sm-3">
					<v-client-table
						:columns="fields"
						:data="data"
						:options="options"
						class="text-center"
					>
						<template v-slot:actions="props">
							<button class="filter-action1" @click="editChannel(props.row)">
								<i class="fa fa-edit"></i> Edit Channel
							</button>
							&nbsp;&nbsp;
						</template>
					</v-client-table>
				</div>
			</div>
			<div class="row pt-3">
				<h4 class="account-title col-sm-8 offset-sm-2">Gateways ({{ sitename }})</h4>
			</div>
			<div class="row pr-5">
				<div class="container-fluid">
					<div class="row" v-for="gate in user.gateway">
						<div class="col-sm-2 offset-sm-2">
							<label class="text-white" for="mac-address">Mac Address</label>
							<input
								class="gateway-input"
								type="text"
								id="mac-address"
								v-model="gate.mac_address"
							/>
						</div>
						<div class="col-sm-2">
							<label class="text-white" for="offset">Offset</label>
							<input
								class="gateway-input"
								type="text"
								id="offset"
								v-model="gate.offset"
							/>
						</div>
						<div class="col-sm-5 d-flex" style="padding-top: 28px">
							<button type="button" class="filter-action1"  @click="deleteGateway(gate)">
								Delete Gateway
							</button>
							&nbsp;
							<button type="button" class="filter-action1" @click="changeGateway(gate)">
								Update Gateway
							</button>
						</div>
					</div>
					<div class="row mt-3" v-if="isAdd">
						<div class="col-sm-2 offset-sm-2">
							<label class="text-white" for="mac-address">Mac Address</label>
							<input
								class="gateway-input"
								type="text"
								id="mac-address"
								v-model="newGateway.macAddress"
							/>
						</div>
						<div class="col-sm-2">
							<label class="text-white" for="offset">Offset</label>
							<input
								class="gateway-input"
								type="text"
								id="offset"
								v-model="newGateway.offset"
							/>
						</div>
						<div class="col-sm-5 d-flex" style="padding-top: 28px">
							<button type="button" class="filter-action1" @click="createGateway">
								Create Gateway
							</button>
						</div>
					</div>
					<div class="row pt-3">
						<div class="col-sm-2 offset-sm-2">
							<button type="button" @click="isAdd=true" class="filter-action1">Add Gateway</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Card>
</template>

<script>
import Card from "@/components/Cards/Card";
import MultiSelect from "@/components/Inputs/multiSelectInput";
import Vue from "vue";
import { ServerTable, ClientTable, Event } from "vue-tables-2";
import { mapActions, mapGetters } from "vuex";
Vue.use(ClientTable);

export default {
	name: "Account",
	components: {
		Card,
		MultiSelect
	},
	computed: {
		...mapGetters({
			periodTime: 'settime/getPeriodTime',
			user: 'auth/getUser'
		})
	},
	data() {
		return {
			name: "",
			email: "",
			password: "",
			repassword: "",
			_repassword: "",
			showCurrentUsers: false,
			lfields: ["name", "email", "access_level"],
			userManageSites: [],
			loptions: {
				headings: {
					name: "name",
					email: "email",
					access_level: "access level"
				},
				sortable: ["name"],
				perPage: 10,
			},
			newUser: {
				name: '',
				email: '',
				password: '',
				repassword: '',
				isAdmin: false
			},
			updatedUser: {
				name: '',
				email: '',
				password: '',
				repassword: ''
			},
			adminValues: [
				{ label: 'Client', value: 0 },
				{ label: 'Admin', value: 1 },
				{ label: 'Super Admin', value: 2 },
			],
			sitename: "",
			linkedUsers: [],
			linkedSites: [],
			showError: false,
			errorMessages: [],
			updateErrorMessages: [],
			fields: ["device_name", "actions"],
			data: [],
			isAdd: false,
			newGateway: {
				macAddress: '',
				offset: 0
			},
			options: {
				headings: {
					name: "name",
				},
				sortable: ["device_name"],
				perPage: 10,
			},
			macAddress: "",
			offset: 0,
		};
	},
	watch: {
		updatedUser: {
			handler(newValue, oldValue) {
				this.updatedErrorMessages = [];
			},
			deep: true
		},
		newUser: {
			handler(newValue, oldValue) {
				this.errorMessages = [];
			},
			deep: true
		}
	},
	async created() {
		const channels = await this.getChannels(this.user);
		const sites = await this.getSites(this.user.id);
		this.linkedUsers =  await this.getLinkedUsers(this.user.siteId);

		sites.forEach(element => {
			let item = {
				flag: false,
				id: element.id,
				name: element.sitename
			}

			this.linkedSites.push(item);
		});

		this.updatedUser.name = this.user.name;
		this.updatedUser.email = this.user.email;
		this.sitename = this.user.site;
		this.macAddress = this.user.mac_address;
		this.processChannelData(channels[0]);
	},
	methods: {
		...mapActions({
			getChannels: "admin/getChannels",
			updateUser: "auth/updateUser",
			createUser: "auth/createUser",
			updateGateway: "admin/updateGateway",
			addGateway: "admin/addGateway",
			removeGateway: "admin/removeGateway",
			getSites: "admin/getSites",
			getLinkedUsers: "admin/getLinkedUsers"
		}),
		selectField() {
			console.log(this.newUser);
		},
		async createNewUser() {
			if (this.newUser.name == '') {
				this.errorMessages.push("Please input new user name");
			}

			if (this.newUser.email == '') {
				this.errorMessages.push("Please input new user email");
			}

			if (!this.validEmail(this.newUser.email)) {
				this.errorMessages.push("Please input valid email format");
			}

			if (this.newUser.password == '') {
				this.errorMessages.push("Please input new user password");
			}

			if (this.newUser.password != this.newUser.repassword) {
				this.errorMessages.push("Password does not match, please confirm again");
			}

			if (this.errorMessages.length == 0) {
				const user = await this.createUser({
					name: this.newUser.name, 
					password: this.newUser.password,
					email: this.newUser.email,
					siteId: this.user.siteId,
					admin: this.newUser.isAdmin,
					linkedSites: this.userManageSites
				});

				this.$toasted.show("User is updated successfully", {
					type: "success",
					duration: 2500,
				});

				this.userManageSites = [];
				this.newUser = {
					name: '',
					email: '',
					password: '',
					repassword: '',
					isAdmin: false
				}
				this.$refs.multselect.disselectall();
			}
		},
		validEmail: function (email) {
			let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		},
		async updatePassword() {
			if (this.updatedUser.name == '') {
				this.updateErrorMessages.push("Please input updated user name");
			}

			if (this.updatedUser.email == '') {
				this.updateErrorMessages.push("Please input updated user email");
			}

			if (!this.validEmail(this.updatedUser.email)) {
				this.updateErrorMessages.push("Please input valid email format");
			}
			if (this.updatedUser.password == '') {
				this.updateErrorMessages.push("Please input updated user password");
			}

			if (this.updatedUser.password != this.updatedUser.repassword) {
				this.updateErrorMessages.push("Password does not match, please confirm again");
			}

			if (this.updateErrorMessages.length == 0) {
				const user = await this.updateUser({
					name: this.updatedUser.name, 
					password: this.updatedUser.password,
					email: this.updatedUser.email,
					siteId: this.user.siteId
				});

				this.$toasted.show("User is updated successfully", {
					type: "success",
					duration: 2500,
				});
			}
		},
		onCheck(val) {
			console.log(val)
			this.userManageSites = val;
		},
		editChannel(row) {
			this.$router.push({ name: "edit_channel", params: {id: row.id, channel: row}});
		},
		back() {
			this.$router.push({ name: "admin" });
		},
		processChannelData(data) {
			data.map((item) => {
				this.data.push(item);
			});
		},
		async deleteGateway(gate)
		{
			await this.removeGateway({id:gate.gateway_id});
			let gateway = this.user.gateway.filter(item => item.gateway_id !== gate.gateway_id);
			this.user.gateway = [];
			this.user.gateway = gateway;
			this.$store.commit("auth/setGateway", gateway)
			this.$toasted.show("Gateway is updated successfully", {
				type: "success",
				duration: 2500,
			});
		},
		async changeGateway(gate) {
			let gateway = {
				id: gate.gateway_id,
				mac_address: gate.macAddress,
				offset: gate.offset
			}
			await this.updateGateway(gateway);
			this.$toasted.show("Gateway is updated successfully", {
				type: "success",
				duration: 2500,
			});
		},
		async createGateway() {
			let gateway = {
				mac_address: this.newGateway.macAddress,
				offset: this.newGateway.offset,
				site: this.user.siteId
			}
			let gateways = this.user.gateway;
			gateways.push(gateway);
			this.$store.commit("auth/setGateway", gateways);
			await this.addGateway(gateway);
			this.isAdd = false;
		}
	},
};
</script>

<style lang="scss" scoped>
.back-title {
	color: #4fcf8d;
	cursor: pointer;

	&:hover {
		color: #4fcf00;
		opacity: 0.8;
	}
}

#access_level {
	height: 40px;
    background-color: #1e365d;
    color: white !important;
    opacity: 0.9;
    border: 1px solid #fdfdfd;
    border-radius: 4px;
	width: 25%;
}

table{
  border-collapse: collapse;
  width: 100%;
}

th, td {
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #6258eb;
}

th {
  background-color: #192442;
  color: white;
}

.form-group {
	label {
		color: white;
		font-family: "Nunito Sans Light";
		padding-top: 8px;
	}

	input {
		height: 40px;
		background-color: #1e365d;
		color: white !important;
		opacity: 0.9;
		border: 1px solid #fdfdfd;
		border-radius: 4px;

		&:hover,
		&:active,
		&:focus {
			background-color: #1e365d;
		}
	}
}
.gateway-input {
	height: 30px;
	background: transparent;
	color: white !important;
	opacity: 0.9;
	border: 1px solid #fdfdfd;
	border-radius: 4px;

	&:hover,
	&:active,
	&:focus {
		background-color: #1e365d;
	}
}

.filter-action1 {
	width: 160px;
	height: 30px;
	border: 1px solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	border-radius: 4px;
	z-index: 8;
	font-size: 14px;
	font-family: "Nunito Sans Light";
	&:hover {
		background-color: #1f5881;
	}
}

.update-button {
	width: 120px;
	height: 40px;
	border: 1px solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	border-radius: 4px;
	z-index: 8;
	&:hover {
		background-color: #1f5881;
	}
}

.VueTables__table.table.table-striped.table-bordered.table-hover tbody tr td {
	padding: 2px;
}

.account-title {
	font-family: "Nunito Sans Light";
	font-weight: 100;
}

.show-title {
	box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    padding: 10px;
    font-size: 18px;
    font-weight: 300;
    border: 1px solid #b2b2b2;
    cursor: pointer;
}

.show-title:hover {
	background: #1f5881;
}
</style>
